'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = hoc;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _eventEmitter = require('../Base/views/eventEmitter.c');

var _eventEmitter2 = _interopRequireDefault(_eventEmitter);

var _dataModel = require('../../common/backbone/dataModel');

var _dataModel2 = _interopRequireDefault(_dataModel);

var _dataCollection = require('../../common/backbone/dataCollection');

var _dataCollection2 = _interopRequireDefault(_dataCollection);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash.throttle');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// for event emulation
var preventDefault = function preventDefault() {};
var stopPropagation = function stopPropagation() {};

function hoc(ComponentToWrap) {
    var _class, _temp, _initialiseProps;

    return _temp = _class = function (_EventEmitter) {
        _inherits(_class, _EventEmitter);

        function _class(props) {
            var _ret;

            _classCallCheck(this, _class);

            var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

            _initialiseProps.call(_this);

            var value = _this._getValueFromStorage(),
                collection = _this._getCollection(props);

            if (!value) {
                value = props.defaultValue || null;
            }

            _this.state = {
                value: value,
                // DataCollection only, for data-bind
                collection: collection ? collection.models : null
            };

            _this._listenStorage();
            _this._listenCollection(collection);

            return _ret = _this, _possibleConstructorReturn(_this, _ret);
        }

        _createClass(_class, [{
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (this.props.storage instanceof _dataModel2.default) {
                    this.stopListening(this.props.storage);
                }

                var cll = this._getCollection(this.props);

                if (cll instanceof _dataCollection2.default) {
                    this.stopListening(cll);
                }
            }
        }, {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                var _this2 = this;

                var nextStorage = nextProps.storage;

                // storage был удален
                if (this.props.storage && !nextStorage) {
                    this.stopListening(this.props.storage);
                }

                // обновились хранилища данныех, необходимо переподписаться на новое
                // и обновить актуальное значение
                if (nextStorage && this._needRebindStorage(nextProps)) {
                    this._rebind(nextProps.storage, nextProps.attribute);

                    this.setState({ value: this._getValueFromStorage(nextProps.storage, nextProps.attribute) }, function () {
                        _this2._dispatchSyntheticEvent();
                    });
                }

                var collection = this._getCollection(this.props),
                    newCollection = this._getCollection(nextProps);

                // collection был удален
                if (collection && !newCollection) {
                    this.stopListening(collection);
                }

                if (collection !== newCollection) {
                    this._rebind(newCollection);
                    this.setState({ collection: newCollection || [] });
                }

                return this;
            }

            /**
             * определяет необходимость переподписки на storage при изменении props в componentWillReceiveProps
             * @param {object} nextProps
             * @return {boolean|*}
             * @private
             */

        }, {
            key: '_needRebindStorage',
            value: function _needRebindStorage() {
                var nextProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                var needRebind = false;

                if (this.props.storage !== nextProps.storage) {
                    // we got a new valid Model storage
                    if (nextProps.storage instanceof _dataModel2.default) {
                        needRebind = true;
                    }
                }

                if (this.props.attribute !== nextProps.attribute) {
                    // we got a new valid attribute name
                    if (nextProps.attribute) {
                        needRebind = true;
                    }
                }

                // или изменился storage|attribute
                return needRebind;
            }
        }, {
            key: '_rebind',
            value: function _rebind(nextStorage, attribute) {
                var isModel = nextStorage instanceof _dataModel2.default,
                    isCollection = nextStorage instanceof _dataCollection2.default;

                if (isModel && attribute) {
                    this._listenStorage(nextStorage, attribute);
                } else if (isCollection) {
                    this._listenCollection(nextStorage);
                }

                return this;
            }

            /**
             * Возвращает текущее значение из модели
             * @param {object} storage
             * @param {string} attribute
             * @return {*}
             */

        }, {
            key: '_getValueFromStorage',
            value: function _getValueFromStorage() {
                var storage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.storage;
                var attribute = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props.attribute;

                var value = null;

                if (storage instanceof _dataModel2.default && attribute) {
                    value = storage.get(attribute);
                    value = value instanceof _dataModel2.default ? value.id : value;
                    value = value === undefined ? null : value;
                }

                return value;
            }
        }, {
            key: '_listenStorage',
            value: function _listenStorage() {
                var _this3 = this;

                var storage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.storage;
                var attribute = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props.attribute;

                if (storage instanceof _dataModel2.default && attribute) {
                    this.stopListening(storage);

                    this.listenTo(storage, 'change:' + attribute, function () {
                        if (_this3.__last_updated_value === undefined || _this3.__last_updated_value !== storage.__data_bind_last_updated_value) {
                            _this3.setState({ value: _this3._getValueFromStorage() }, function () {
                                return _this3._dispatchSyntheticEvent();
                            });
                        }

                        delete _this3.__last_updated_value;
                    });
                }

                return this;
            }
        }, {
            key: '_listenCollection',
            value: function _listenCollection(collection) {
                var _this4 = this;

                if (collection instanceof _dataCollection2.default) {
                    // коллекция тригерит слишком много событий при изменеии чего либо
                    this.listenTo(collection, 'all', (0, _lodash2.default)(function () {
                        _this4.setState({ collection: [].concat(collection.models) });
                    }, 50, { leading: false }));

                    return this;
                }
            }

            /**
             * обновление модели при изменении значения компонента
             * @private
             * @param {*} value
             * @return {object}
             */

        }, {
            key: '_updateStorage',
            value: function _updateStorage() {
                var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.value;

                if (this.props.storage instanceof _dataModel2.default && this.props.attribute) {
                    this.props.storage.__data_bind_last_updated_value = value;
                    this.props.storage.set(this.props.attribute, value, { validate: false });
                }

                return this;
            }
        }, {
            key: '_createRef',
            value: function _createRef(el) {
                if (typeof this.props.elementRef === 'function') {
                    this.props.elementRef(el);
                }

                this.componentRef = el;
            }
        }, {
            key: '_format',
            value: function _format() {
                var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

                if (typeof this.props.format === 'function') {
                    value = this.props.format(value);
                }

                return value;
            }
        }, {
            key: '_toString',
            value: function _toString() {
                var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.value;

                if (typeof this.props.stringify === 'function') {
                    return this.props.stringify(value);
                }

                if (value === undefined || value === null) {
                    value = '';
                } else if (typeof value === 'number') {
                    value = String(value);
                }

                return value;
            }
        }, {
            key: '_dispatchSyntheticEvent',
            value: function _dispatchSyntheticEvent() {
                var event = void 0;

                if (this._lastOnChangeEvent) {
                    event = this._lastOnChangeEvent;
                } else {
                    // симулируем событие, когда истоником изменения является модель, а не onChange
                    event = {
                        target: this.componentRef,
                        currentTarget: this.componentRef,
                        preventDefault: preventDefault,
                        stopPropagation: stopPropagation,
                        type: 'change'
                    };
                }

                if (typeof this.props.onChange === 'function') {
                    this.props.onChange(event);
                }

                delete this._lastOnChangeEvent;
            }

            /**
             * находит коллекцию среди this.props
             * приоритет:
             *      this.props.collection
             *      this.props.storage[attribute].allowedValues
             * @private
             * @param {object} props
             * @return {object}
             */

        }, {
            key: '_getCollection',
            value: function _getCollection() {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

                var collection = void 0,
                    attribute = props.attribute;

                if (props.collection instanceof _dataCollection2.default || props.collection instanceof Array) {
                    collection = props.collection;
                } else if (props.storage instanceof _dataModel2.default && attribute && props.storage.fields && props.storage.fields[attribute] && (props.storage.fields[attribute].allowedValues instanceof Array || props.storage.fields[attribute].allowedValues instanceof _dataCollection2.default)) {
                    collection = props.storage.fields[attribute].allowedValues;
                }

                return collection;
            }
        }, {
            key: 'render',
            value: function render() {
                var props = Object.assign({}, this.props, {
                    onChange: this._handleChange,
                    value: this._toString(),
                    elementRef: this._createRef.bind(this),
                    name: this.props.name || this.props.attribute
                });

                if (this.state.collection || this.props.collection) {
                    // DataCollection || Array
                    props.collection = this.state.collection || this.props.collection;
                }

                if (this.props.isCheckbox) {
                    props.checked = !!this.state.value;
                }

                if (this.props.isRadio) {
                    // оставляем оригинальное значение value
                    props.value = this.props.value;
                    props.checked = String(this.props.value) === this._toString();
                }

                // data bind not allow uncontrolled components
                // defaultValue is placeholder of model value
                delete props.defaultValue;

                return _react2.default.createElement(
                    ComponentToWrap,
                    props,
                    this.props.children
                );
            }
        }]);

        return _class;
    }(_eventEmitter2.default), _class.wrappedComp = ComponentToWrap, _class.propTypes = {
        onValid: _propTypes2.default.func,
        onChange: _propTypes2.default.func,
        elementRef: _propTypes2.default.func,
        stringify: _propTypes2.default.func,
        format: _propTypes2.default.func,
        isCheckbox: _propTypes2.default.bool,
        isRadio: _propTypes2.default.bool,
        collection: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object])
    }, _class.displayName = 'DataBind(' + (ComponentToWrap.displayName || '') + ')', _initialiseProps = function _initialiseProps() {
        var _this5 = this;

        this._handleChange = function () {
            var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var value = _this5.props.isCheckbox ? event.target.checked : event.target.value;
            _this5._lastOnChangeEvent = Object.assign({}, event);
            _this5.__last_updated_value = value;

            _this5.setState({
                value: _this5._format(value)
            }, function () {
                _this5._updateStorage(value);
                _this5._dispatchSyntheticEvent();
            });
        };
    }, _temp;
}